import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { FetchLoadEvents, logisticsActionCreators, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { ILoadEvent } from '../logisticsInterfaces';

function* fetchLoadEventsSaga(action: FetchLoadEvents) {
  yield put(uiActionCreators.toggleLoading('loadEvents'));

  const response = yield* call(fetch, action.payload.loadNumber);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setEvents(response.value));
  }

  yield put(uiActionCreators.toggleLoading('loadEvents'));
}

export function* watchFetchLoadEvents() {
  yield takeEvery(LogisticsActionKeys.FETCH_LOAD_EVENTS, fetchLoadEventsSaga);
}

export async function fetch(loadNumber: string): Promise<IApiExecuteRespone<ILoadEvent[]>> {
  return executeApiRequest(() => httpService.get(ApiUrls.loads({ loadNumber, type: { events: true } })));
}
